import React, { useEffect } from 'react';

import { firstLoadOfData, useManagedMailSubscriptionModal } from '@/entities/mailSubscription';

import { APP_ELEMENTS, MODAL_ELEMENTS } from '@/shared/constants';
import { useAppDispatch, useAppSelector } from '@/shared/hooks/appRedux';
import { getLoading } from '@/shared/services/loading';
import { LoadingBackground } from '@/shared/services/modal';

const MailSubscriptionPage: React.FC = () => {
  const loading = useAppSelector(getLoading);
  const dispatch = useAppDispatch<MailSubscriptionAppDispatch>();

  useEffect(() => {
    if (window.mailSubscription) dispatch(firstLoadOfData(window.mailSubscription));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useManagedMailSubscriptionModal();
  return (
    <LoadingBackground
      loading={loading}
      appElement={APP_ELEMENTS.MAIL_SUBSCRIPTION}
      parentSelector={MODAL_ELEMENTS.MAIL_SUBSCRIPTION_MODAL}
    />
  );
};

export default MailSubscriptionPage;
